import React from 'react'
import { CheckboxControl } from 'spark-core-dx/components';
import { useVisualFormContext } from '../../../contexts/VisualFormContext';

export const Lock = () => {
    const { visualObject, setVisualObject } = useVisualFormContext();

    return (
        <div className="visual-lock-section">
            <div
                className="visual-lock-title"
                style={{
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontWeight: 700,
                    lineHeight: "1.25rem",
                    margin: 0,
                }}
            >
                Global Filters
            </div>
            <div
                className="visual-lock-row"
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    paddingBottom: "1rem",
                    marginTop: "0.5rem",
                }}
            >
                <CheckboxControl
                    value={visualObject?.IsLocked}
                    onChange={() => {
                        setVisualObject(prev => ({
                            ...prev,
                            IsLocked: !visualObject?.IsLocked,
                        }));
                    }}
                />
                <span
                    className="visual-lock-label"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        minHeight: "1.5rem",
                        fontFamily: "Roboto",
                        fontWeight: 400,
                        lineHeight: "1.25rem",
                    }}
                >
                    Lock visual to ignore global filters
                </span>
            </div>
        </div>
    )
}
